import { Inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { RequestService } from '@services/http/request/request.service';
import { APP_CONFIG, AppConfig } from '@src/app.config';

export interface ImpersonationState {
  active: boolean;
  actorIdentityUserId?: string;
  actorDisplayName?: string;
  targetIdentityUserId?: string;
  targetDisplayName?: string;
}

export interface ImpersonationTokenResponse {
  accessToken: string;
  refreshToken: string;
  expires: number;
  impersonation: ImpersonationState;
}

@Injectable({ providedIn: 'root' })
export class ImpersonationApiService {
  constructor(
    @Inject(APP_CONFIG) private readonly appConfig: AppConfig,
    private readonly requestService: RequestService,
  ) {}

  start(targetIdentityUserId: string): Observable<ImpersonationTokenResponse> {
    const url = `${this.appConfig.angularEndpoint}/auth/impersonationStart`;
    return this.requestService.post(url, { targetIdentityUserId }).pipe(
      map(res => res.body as ImpersonationTokenResponse),
    );
  }

  stop(): Observable<ImpersonationTokenResponse> {
    const url = `${this.appConfig.angularEndpoint}/auth/impersonationStop`;
    return this.requestService.post(url).pipe(
      map(res => res.body as ImpersonationTokenResponse),
    );
  }

  state(): Observable<ImpersonationState> {
    const url = `${this.appConfig.angularEndpoint}/auth/impersonationState`;
    return this.requestService.get(url).pipe(
      map(res => res.body as ImpersonationState),
    );
  }
}
